/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';
import Header from './Header';

const TopPanels = styled.div`
  width: 100%;
  margin-bottom: 5px;
  .panel.dark .headline-wrapper {
    padding: 0;
    max-width: 768px;
    margin: 0 auto;
    .headline {
      padding: 20px;
      .super {
        color: #999;
        text-decoration: none;
        h5 {
          font-size: 1rem;
          margin-bottom:10px;
        }
        &:hover {
          h5 {
            opacity: 0.8;
          }
        }
      }
      h1 {
        font-size: 2.5rem;
        line-height: 3rem;
      }
      .series-dek {
        font-size: 18px;
        line-height: 24px;
      }
      .series-name {
        display: none;
        padding: 0;
        font-size: 1rem;
        line-height: 1.1;
      }
    }
  }

  @media screen and (min-width: 1000px) {
    margin-bottom: 50px;
    display: flex;
    flex-direction: row-reverse;
    .panel {
      width: 40%;
      min-height: 50vw;
      height: 80vh;
      &.dark {
        background: #090822;
        color: white;
        .headline-wrapper {
          max-width: none;
          transform: translateY(-16px);
          pointer-events: none;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          .headline {
            height: auto;
            .super {
              pointer-events: auto;
              color: white;
            }
            h1 {
              font-size: 3.4rem;
              margin-bottom: 20px;
              line-height: 1.1;
            }
            .series-hed, .series-dek {
              max-width: 360px;
            }
            .series-dek {
              font-size: 1.2rem;
              line-height: 1.7rem;
            }
            .series-name {
              display: block;
              padding: 20px 0 0;
              font-size: 1rem;
              line-height: 1.1;
              border-top: 3px solid #fff;
            }
          }
        }

      }
      &.photo {
        width: 60%;
        overflow: hidden;
        img {
          min-height: 50vw;
          height: 80vh;
          object-fit: cover;
          &.objectPositionRight {
            object-position: 85% center;
          }
          &.objectPositionLeft {
            object-position: 25% center;
          }
        }
      }
    }
  }
  @media screen and (min-width: 1000px) {
    .panel.dark .headline {
      padding: 10% 20%;
      h1 {
        font-size: 3.5rem;
      }
    }
  }
  @media screen and (max-width: 999px) {
    .hero-img {
      width: 100%;
    }
  }
`;
const HeroCaption = styled.div`
  display: none;
  @media screen and (min-width: 1000px) {
    display: block;
    figcaption {
      display: block;
      max-width: 40vw;
      line-height: 1.2;
      letter-spacing: .65px;
      transform: translate(25%, -40px);
      padding: 0;
    }
  }
`;

const Topper = ({ children, heroImage }) => {
  const imgSrc = heroImage.url ? heroImage.url : heroImage.src || '';
  // if this is a day oneimage, we want class
  const imgAlign = heroImage.imgAlign ? `hero-img ${heroImage.imgAlign}` : 'hero-img';
  const imgCredit = (heroImage.credit && heroImage.credit.name) ? (<span className="img_credit">({heroImage.credit.name})</span>) : null;

  return (
    <React.Fragment>
      <TopPanels>
        <div className="panel photo">
          <Header hclass="white show-on-mobile" />
          <img
            src={imgSrc}
            srcSet={heroImage.srcSet}
            sizes="100vw"
            className={imgAlign}
            alt={heroImage.caption}
          />
        </div>
        <div className="panel dark">
          <Header hclass="gray hide-on-mobile" />
          <div className="headline-wrapper">
            <div className="panel-content headline">
              {children}
            </div>
          </div>
        </div>
      </TopPanels>
      <HeroCaption className="hero_caption">
        <figcaption className="img_caption">
          <div className="caption bentonsanscond-n4">{heroImage.caption} {imgCredit}</div>
        </figcaption>
      </HeroCaption>
    </React.Fragment>
  );
};

export default Topper;
